
  import { css } from 'lit';
  export const styles = css`[part=ranges]{max-height:max(var(--is-large, 1) * max(6.75rem, -1 * 6.75rem), var(--is-medium, 1) * max(6rem, -1 * 6rem), var(--is-small, 1) * max(5.25rem, -1 * 5.25rem))}`;
  